import React, { useMemo, useState, useEffect, useCallback } from "react";
import MaterialReactTable from "material-react-table";
import axios from "axios";

const OmAsistecial = ({ institucion }) => {
  const [Indicador, setIndicador] = useState([]);
  const [loading, setLoading] = useState(false);

  // 🔥 Obtener datos
  const fetchData = useCallback(async () => {
    if (!institucion) return;

    try {
      setLoading(true);

      const response = await axios({
        method: "get",
        auth: {
          username: "BasicAuth@icontec.org",
          password: "yQLzqmR7eZSuAmQZUqhY",
        },
        url:
          "https://suadesarrollo.azurewebsites.net/api/ObtenerOmPorInstitucion/" +
          institucion,
      });

      console.log("DATA API 👉", response.data); // 👈 DEBUG

      setIndicador(response.data || []);
    } catch (error) {
      console.error("ERROR API ❌", error);
    } finally {
      setLoading(false);
    }
  }, [institucion]);

  // 🔥 Ejecutar carga inicial
  useEffect(() => {
    fetchData();
  }, [fetchData]);

  // 🔥 FILTRO CORREGIDO (NUMÉRICO)
  const dataFiltrada = useMemo(() => {
    return Indicador.filter((e) => Number(e.asistencial) === 1);
  }, [Indicador]);

  const grupos = ["A1", "A2", "A3", "A4", "A5", "A6", "A7", "A8", "A9", "A10"];

  // 🔥 Columnas
  const columns = useMemo(
    () => [
      { accessorKey: "id", header: "Id" },
      {
        accessorKey: "estadoOportunidad",
        header: "Estado Oportunidad",
        filterVariant: "multi-select",
        filterSelectOptions: grupos,
      },
      { accessorKey: "origen", header: "Origen" },
      { accessorKey: "tipoVisita", header: "Tipo Visita" },
      { accessorKey: "descripcion", header: "Descripcion" },
    ],
    [],
  );

  return (
    <MaterialReactTable
      columns={columns}
      data={dataFiltrada}
      state={{ isLoading: loading }}
      enableRowSelection
      enableMultiRowSelection
      autoResetPageIndex={false} // ✅ evita que el paginador se reinicie
      muiTablePaginationProps={{
        rowsPerPageOptions: [5, 10, 20],
      }}
      renderTopToolbarCustomActions={({ table }) => {
        const handleActualizar = async () => {
          const rows = table.getSelectedRowModel().flatRows;

          if (rows.length === 0) {
            alert("Selecciona al menos un registro");
            return;
          }

          try {
            for (const row of rows) {
              await axios({
                method: "put",
                url:
                  "https://suadesarrollo.azurewebsites.net/api/ActualizaIndicadorFicha?Id=" +
                  row.getValue("id"),
                data: {
                  ficha: "priorizado",
                },
              });
            }

            alert("Actualizado correctamente ✅");
            fetchData(); // 🔥 refresca sin recargar página
          } catch (error) {
            console.error(error);
            alert("Error al actualizar ❌");
          }
        };

        return (
          <g></g>
          //<button className="btn btn-primary" onClick={handleActualizar}>
          // Priorizar
          //</button>
        );
      }}
    />
  );
};

export default OmAsistecial;
